export const studioFacts = {
  legalName: 'JUST SEE LTD',
  registrationCountry: 'Cyprus',
  registrationNumber: 'HE 492016',
  tin: '60353616U',
  vatNumber: 'Pending registration',
  address: '1 Kalymnou, "Q MERITO", 4th floor, Agios Nikolaos, Kamares, 6037 Larnaca, Cyprus',
  addressLines: [
    '1 Kalymnou',
    '"Q MERITO", 4th floor',
    'Agios Nikolaos, Kamares',
    '6037 Larnaca, Cyprus',
  ],
  founded: 2026,
  timezone: 'GMT+2 / GMT+3',
  workingHours: 'Mon-Fri, 09:00-18:00 Cyprus time',
};

export const howWeWork = [
  {
    title: 'Communication',
    body: 'Email for async updates and file delivery. Weekly video call to review progress. You talk to the people doing the work, not to an account manager.',
  },
  {
    title: 'Tools we use',
    body: 'Figma for design. Linear for project tracking. Git for code. You get access to all three from day one.',
  },
  {
    title: 'Working hours',
    body: 'Monday to Friday, Cyprus time (GMT+2/+3). We reply within one business day. We do not work weekends unless a launch demands it.',
  },
  {
    title: 'Contracts',
    body: 'Short written proposal per project, signed before work starts. NDA on request at no extra cost.',
  },
];

export const idealClients = {
  forWho: [
    'Founders shipping their first serious brand',
    'Small teams replacing a template site with something real',
    'Businesses tired of agency bloat and missed deadlines',
    'Clients who value craft over the cheapest quote',
  ],
  notForWho: [
    'Shoppers sorting agencies by price alone',
    'Projects that need a logo delivered tomorrow',
    'Clients looking for SEO content farms or ad campaigns',
    'Teams with more than ten stakeholders signing off every detail',
  ],
};

export const briefChecklist = [
  'A sentence or two about what your business does',
  'Who the site or logo is for (customers, investors, both)',
  'Links to sites or brands you respect - and why',
  'Rough timeline: when do you want to launch?',
  'Rough budget range, even if you are not sure yet',
  'Anything technical we should know (existing site, hosting, CMS)',
];

export const whoWeWorkWith = [
  { label: 'Founders', description: 'First brand, first site, first serious hire.' },
  { label: 'Small teams', description: 'Replacing a template, upgrading an MVP, growing past the first year.' },
  { label: 'Indie SaaS', description: 'A marketing site that matches the product quality inside the app.' },
  { label: 'Professional services', description: 'Clinics, studios, consultants, and anyone who needs a site that reads as serious.' },
];

export const howToChoose = [
  { condition: 'Brand exists, site does not', recommendation: 'Website Design + Website Development' },
  { condition: 'Brand feels tired, starting over', recommendation: 'Logo Design first, then site later' },
  { condition: 'Starting from zero', recommendation: 'Full Identity bundle' },
  { condition: 'Site exists, mark needs work', recommendation: 'Logo Design only' },
  { condition: 'Design in hand, need build', recommendation: 'Website Development only' },
];

export const whatWeDoNotDo = [
  'Ads, paid media, or performance marketing campaigns',
  'SEO content writing or link-building services',
  'WordPress, Shopify, or Webflow theme customisation',
  'Print-only design (packaging, editorial layouts, book covers)',
  'Ongoing social media management',
  'Mobile app design or native app development',
];

export const popularDestinations = [
  { label: 'Services', href: '/services' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Contact', href: '/contact' },
];
